import { post, get } from '../axios'

// 新增流程节点天数配置
export function config_add_config_flow_day_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-config-flow-day`,
    map,
    option
  ).then(response => response)
}

// 新增工作台配置
export function config_add_config_permissions_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-config-permissions`,
    map,
    option
  ).then(response => response)
}

// 新增产品品类对应价格占比配置
export function config_add_config_product_price_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-config-product-price`,
    map,
    option
  ).then(response => response)
}

// 编辑二级品类尺码配置
export function config_add_config_product_size_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-config-product-size`,
    map,
    option
  ).then(response => response)
}

// 新增设计师、版师、工艺员对应关系配置
export function config_add_config_staff_match_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-config-staff-match`,
    map,
    option
  ).then(response => response)
}

// 新增流程配置
export function config_add_process_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-process`,
    map,
    option
  ).then(response => response)
}

// 新增流程节点配置
export function config_add_process_node_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-process-node`,
    map,
    option
  ).then(response => response)
}

// 新增流程节点关系
export function config_add_process_node_relation_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-process-node-relation`,
    map,
    option
  ).then(response => response)
}

// 新增流程节点配置
export function config_add_process_node_state_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-process-node-state`,
    map,
    option
  ).then(response => response)
}

// 提交供应商支付周期数据
export function config_add_supplier_cycle_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-supplier-cycle`,
    map,
    option
  ).then(response => response)
}

// 删除流程节点天数配置
export function config_del_config_flow_day_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/del-config-flow-day`,
    map,
    option
  ).then(response => response)
}

// 删除工作台配置
export function config_del_config_permissions_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/del-config-permissions`,
    map,
    option
  ).then(response => response)
}

// 删除产品品类对应价格占比配置
export function config_del_config_product_price_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/del-config-product-price`,
    map,
    option
  ).then(response => response)
}

// 新增设计师、版师、工艺员对应关系配置
export function config_del_config_staff_match_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/del-config-staff-match`,
    map,
    option
  ).then(response => response)
}

// 删除供应商支付周期数据
export function config_del_supplier_cycle_get(map, option) {
  return get(
    `${process.env.VUE_APP_CONFIG}/config/del-supplier-cycle`,
    map,
    option
  ).then(response => response)
}

// 刪除流程节点配置
export function config_delete_process_node_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/delete-process-node`,
    map,
    option
  ).then(response => response)
}

// 刪除流程节点关系
export function config_delete_process_node_relation_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/delete-process-node-relation`,
    map,
    option
  ).then(response => response)
}

// 刪除流程节点配置
export function config_delete_process_node_state_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/delete-process-node-state`,
    map,
    option
  ).then(response => response)
}

// 根据sk查询cp
export function config_get_cp_by_skc_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/get-cp-by-skc`,
    map,
    option
  ).then(response => response)
}

// 导入价格品类
export function config_importSupplierInfo_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/importSupplierInfo`,
    map,
    option
  ).then(response => response)
}

// 初始化cp-skc
export function config_init_cp_skc_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/init-cp-skc`,
    map,
    option
  ).then(response => response)
}

// 查询服装配置码值列表
export function config_list_category_size_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-category-size`,
    map,
    option
  ).then(response => response)
}

// 系统配置列表查询
export function config_list_config_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-config`,
    map,
    option
  ).then(response => response)
}

// 利润率配置查询
export function config_list_config_benefit_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-config-benefit`,
    map,
    option
  ).then(response => response)
}

// 流程节点天数配置查询
export function config_list_config_flow_days_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-config-flow-days`,
    map,
    option
  ).then(response => response)
}

// 报表流程节点天数
export function config_list_config_flow_days_report_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-config-flow-days-report`,
    map,
    option
  ).then(response => response)
}

// 工作台权限配置列表
export function config_list_config_permissions_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-config-permissions`,
    map,
    option
  ).then(response => response)
}

// 产品品类对应价格占比配置表查询
export function config_list_config_product_price_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-config-product-price`,
    map,
    option
  ).then(response => response)
}

// 系统配置列表查询
export function config_list_config_size_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-config-size`,
    map,
    option
  ).then(response => response)
}

// 设计师、版师、工艺员对应关系配置查询
export function config_list_config_staff_match_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-config-staff-match`,
    map,
    option
  ).then(response => response)
}

// 供应商主数据查询
export function config_list_config_supplier_info_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-config-supplier-info`,
    map,
    option
  ).then(response => response)
}

// 供应商仓库映射配置查询
export function config_list_config_warehouse_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-config-warehouse`,
    map,
    option
  ).then(response => response)
}

// 查询流程配置
export function config_list_process_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-process`,
    map,
    option
  ).then(response => response)
}

// 查询流程节点信息
export function config_list_process_name_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-process-name`,
    map,
    option
  ).then(response => response)
}

// 查询流程节点配置
export function config_list_process_node_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-process-node`,
    map,
    option
  ).then(response => response)
}

// 查询流程配置名称
export function config_list_process_node_name_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-process-node-name`,
    map,
    option
  ).then(response => response)
}

// 查询流程节点状态关系
export function config_list_process_node_relation_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-process-node-relation`,
    map,
    option
  ).then(response => response)
}

// 查询流程节点状态配置
export function config_list_process_node_state_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-process-node-state`,
    map,
    option
  ).then(response => response)
}

// 查询产品分类
export function config_list_product_category_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-product-category`,
    map,
    option
  ).then(response => response)
}

// 员工查询信息
export function config_list_staff_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-staff`,
    map,
    option
  ).then(response => response)
}

// 员工查询信息
export function config_list_staff_all_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-staff-all`,
    map,
    option
  ).then(response => response)
}

// 查询供应商支付周期数据
export function config_list_supplier_cycle_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-supplier-cycle`,
    map,
    option
  ).then(response => response)
}

// 二维码
export function config_qr_code_url_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/qr-code-url`,
    map,
    option
  ).then(response => response)
}

// 查询用户权限
export function config_query_config_permissions_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/query-config-permissions`,
    map,
    option
  ).then(response => response)
}

// 查询按钮
export function config_query_menu_button_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/query-menu-button`,
    map,
    option
  ).then(response => response)
}

// 提交利润率配置
export function config_submit_config_benefit_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/submit-config-benefit`,
    map,
    option
  ).then(response => response)
}

// 提交易仓供应商配置表
export function config_submit_config_supplier_info_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/submit-config-supplier-info`,
    map,
    option
  ).then(response => response)
}

// 提交供应商仓库映射配置
export function config_submit_config_warehouse_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/submit-config-warehouse`,
    map,
    option
  ).then(response => response)
}

// 提交编辑新增供应商
export function config_submit_edit_add_supplier_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/submit-edit-add-supplier`,
    map,
    option
  ).then(response => response)
}

// 供应商编辑页面
export function config_supplier_edit_infos_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/supplier-edit-infos`,
    map,
    option
  ).then(response => response)
}

// 更新流程节点天数配置
export function config_update_config_flow_day_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/update-config-flow-day`,
    map,
    option
  ).then(response => response)
}

// 更新工作台配置
export function config_update_config_permissions_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/update-config-permissions`,
    map,
    option
  ).then(response => response)
}

// 供应商列表导出
export function config_export_post(map, option) {
  return post(`${process.env.VUE_APP_CONFIG}/config/export`, map, option).then(
    response => response
  )
}

// 新增节假日配置
export function config_add_holiday_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-holiday`,
    map,
    option
  ).then(response => response)
}

// 节假日查询
export function config_list_holiday_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-holiday`,
    map,
    option
  ).then(response => response)
}

// renew流程节点信息
export function config_renew_process_name_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/renew-process-name`,
    map,
    option
  ).then(response => response)
}

// renew流程节点信息V2
export function config_renew_process_name_v2_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/renew-process-name-v2`,
    map,
    option
  ).then(response => response)
}

// 获取动态列值
export function config_list_column_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-column`,
    map,
    option
  ).then(response => response)
}

// cp自动取号配置查询
export function config_list_config_automatic_number_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-config-automatic-number`,
    map,
    option
  ).then(response => response)
}

// 新增cp自动取号配置
export function config_add_config_automatic_number_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/add-config-automatic-number`,
    map,
    option
  ).then(response => response)
}

// 删除cp自动取号配置
export function config_delete_config_automatic_number_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/delete-config-automatic-number`,
    map,
    option
  ).then(response => response)
}

// 编辑cp自动取号配置
export function config_edit_config_automatic_number_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/edit-config-automatic-number`,
    map,
    option
  ).then(response => response)
}

// 流程节点模板下载url
export function config_get_process_node_url_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/get-process-node-url`,
    map,
    option
  ).then(response => response)
}

// 上传流程节点明细
export function config_upload_process_node_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/upload-process-node`,
    map,
    option
  ).then(response => response)
}

// 获取流程节点明细
export function config_get_process_node_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/get-process-node`,
    map,
    option
  ).then(response => response)
}

// 获取动态菜单列
export function config_list_menu_field_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-menu-field`,
    map,
    option
  ).then(response => response)
}

// 更新动态菜单列
export function config_update_menu_field_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/update-menu-field`,
    map,
    option
  ).then(response => response)
}

// 查询产品分类(精确到二级类目)
export function config_list_product_second_category_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/list-product-second-category`,
    map,
    option
  ).then(response => response)
}

// 重置密码
export function config_reset_password_post(map, option) {
  return post(
    `${process.env.VUE_APP_CONFIG}/config/reset-password`,
    map,
    option
  ).then(response => response)
}
